import { Injectable } from '@angular/core';
import { createEffect, Actions } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { of, from } from 'rxjs';
import * as fromTemplateDetail from './template-detail.actions';
import { TemplateDetailState } from './template-detail.interfaces';
import { ApiService } from '@quorum/api';
// eslint-disable-next-line max-len
import {
  VehicleTemplateDetail,
  VehicleMaintenanceSchedule
} from '@quorum/models/xs-resource';
// eslint-disable-next-line max-len
import { VehicleMaintenanceScheduleQueryParameters } from '@quorum/models/xs-query';
import { switchMap, map } from 'rxjs/operators';
@Injectable()
export class TemplateDetailEffects {
  
  getMaintenanceScheduleFromServer = createEffect(() => this.dataPersistence.fetch(fromTemplateDetail.GET_TEMPLATE_DETAIL_FROM_SERVER, {
    run: (action: fromTemplateDetail.GetTemplateDetailsFromServer, state: TemplateDetailState) => {
      return this.apiService
        .get<VehicleMaintenanceSchedule>(`v/1/vehicles/vehicle-maintenance-schedules`, {
          params: { vehicleId: action.payload.vehicleId }
        })
        .pipe(
          switchMap((vehicleMaintenanceSchedule: any) => {
            if (vehicleMaintenanceSchedule.length > 0) {
              return this.apiService
                .get<VehicleTemplateDetail[]>(`v/1/vehicle/vehicle-template-detail`, {
                  params: { headerId: vehicleMaintenanceSchedule[0].templateHeaderId }
                })
                .pipe(
                  map(templateDetail => {
                    if (templateDetail.length === 0) {
                      return new fromTemplateDetail.GetTemplatedetailFromServerFailure({
                        error: 'The maintenance schedule applied to this vehicle has no services'
                      });
                    }
                    return new fromTemplateDetail.GetTemplateDetailFromServerSuccess({
                      templateDetail: templateDetail
                    });
                  })
                );
            } else {
              return from([
                new fromTemplateDetail.GetTemplatedetailFromServerFailure({
                  error: 'No maintenance schedule template found for this vehicle'
                })
              ]);
            }
          })
        );
    },
    onError: (action: fromTemplateDetail.GetTemplateDetailsFromServer, error) => {
      console.error('Error', error);
      return new fromTemplateDetail.GetTemplatedetailFromServerFailure({
        error: 'The maintenance schedule for this vehicle could not be loaded.'
      });
    }
  }));

  constructor(
    private actions: Actions,
    private dataPersistence: DataPersistence<TemplateDetailState>,
    private apiService: ApiService
  ) {}
}
